import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Question from 'theme/assets/images/question.svg';
import TabClick from 'modules/common/TabClick';
import {FormattedMessage} from 'react-intl';
import cx from 'classnames';
import CommonErrorsButton from './CommonErrorsButton';
import {
  bgBlueLight,
  helpHint,
  scrollArea,
  helpScroll,
  preWrap,
  skeleton,
} from './styles.scss';

class HelpContent extends Component {
  static propTypes = {
    code_challenge_helper_youtube_id: PropTypes.string,
    task: PropTypes.object.isRequired,
    is_help_used: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {helpVisible: false, fakeLoading: false, clicked: 0};
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.task.id !== this.props.task.id) {
      this.setState({helpVisible: false});
    }
  }

  toggleHelp = () => {
    this.setState((state) => ({
      helpVisible: !state.helpVisible,
      clicked: state.clicked + 1,
    }));
    if (this.state.clicked === 0) {
      setTimeout(() => {
        this.setState((state) => ({fakeLoading: !state.fakeLoading}));
      }, 3000);
    } else {
      this.setState({fakeLoading: true});
    }
  };

  render() {
    const {code_challenge_helper_youtube_id, task, is_help_used} = this.props;
    const {helpVisible, fakeLoading} = this.state;
    return (
      <div>
        {!code_challenge_helper_youtube_id && !task.hint ? null : (
          <TabClick color={bgBlueLight} title={<FormattedMessage id="help" />}>
            <div className="mr3">
              <CommonErrorsButton
                className="gray flex items-center pv3 pointer"
                code_challenge_helper_youtube_id={
                  code_challenge_helper_youtube_id
                }
              />
              <div
                className="gray flex items-center pv3 pointer mh0"
                onClick={is_help_used}
              >
                {task.hint && (
                  <div
                    className="ml2 mb2 w-100"
                    color="#19a974"
                    onClick={this.toggleHelp}
                  >
                    <div className="flex">
                      <img className="ml2" src={Question} alt="need help" />
                      <div className={cx('mt1', {fw6: helpVisible})}>
                        <FormattedMessage id="need_help_deduct" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {helpVisible && (
                <div
                  className={cx('ph2', {
                    [`${scrollArea} ${helpScroll} ltr`]: fakeLoading,
                  })}
                >
                  {fakeLoading ? (
                    <p
                      className={cx('pa3 mb2 rtl', helpHint, preWrap)}
                      dangerouslySetInnerHTML={{
                        __html: task.hint,
                      }}
                    />
                  ) : (
                    [0, 1].map((item) => (
                      <div key={item} className={skeleton} />
                    ))
                  )}
                </div>
              )}
            </div>
          </TabClick>
        )}
      </div>
    );
  }
}

export default HelpContent;
